export default {
  SET_LINKEDIN_AUTH(state, payload) {
    state.linkedinAuth = payload;
  },
};
